<template>
  <Layout1>
    <template slot="slot_title">
      <RT id="priRT" :options="'新增推播_指定推播_已傳送_草稿'.split('_')" :defaultValue="page" @input="$router.replace({ name: $route.name, query: { ...$route.query, page: $event } })"></RT>
      <PageNum :max="max" v-if="['已傳送', '草稿'].includes(page)" :style="{marginLeft: 'auto', marginRight: '32px'}" :defaultValue="pagenum" @input="pagenum=$event" :text="true"></PageNum>
    </template>
    <Selected v-if="page==='指定推播'" :info="info" :page="pagenum"/>
    <Filters v-else-if="page==='新增推播'" :info="info" :page="pagenum"/>
    <List v-else-if="page==='已傳送'" :info="info" :page="pagenum" @count="count=$event"/>
    <PreList v-else :info="info" :page="pagenum" @count="count=$event"/>
  </Layout1>
</template>

<script>
import Layout1 from '../../components/layout/L1.vue'
import PageNum from '../../components/input/page.vue'
import Selected from './selected.vue'
import Filters from './filter.vue'
import List from './List.vue'
import PreList from './preList.vue'
import { getapi } from '../../store/fetch'
export default {
  components: {
    Layout1,
    Selected,
    Filters,
    List,
    PreList,
    PageNum
  },
  computed: {
    max () {
      return Math.ceil(this.count / 7)
    },
    page () {
      return this.$route.query.page
    },
    query () {
      const q = this.$route.query
      delete q.page
      return q
    }
  },
  data () {
    return {
      pagenum: 1,
      count: 0,
      info: {
        signup: 0,
        offcial: 0,
        limitMax: 0,
        isLimit: 0,
        countUsed: 0
      }
    }
  },
  async mounted () {
    await this.getMsgNumber()
  },
  watch: {
    page () {
      this.pagenum = 1
    }
  },
  methods: {
    async getMsgNumber () {
      const r = await getapi('message/number')
      if (r) {
        this.info.limitMax = r.limit.value
        this.info.isLimit = r.limit.type
        this.info.countUsed = r.used
        this.info.offcial = r.offcial
        this.info.signup = r.signup
      }
    }
  }

}
</script>

<style lang="scss">
#priRT>input[type=radio] {
  min-width: 130px;
}
#priRT>input[type=radio]:checked {
  background-color: var(--color-pri);
}
</style>
